import loadable from '@loadable/component';

// TODO сделать чтобы модальное окно грузилось по востребованию (после того как произойдёт клик по кнопке "Район")
export const DistrictsPopupContainerLoadable = loadable(() => import('./DistrictsPopupContainer'), {
  ssr: false,
  resolveComponent: module => module.DistrictsPopupContainer,
});
